import { Modal, ModalTabs, PDFRenderer } from "components";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import config from "config";
import { useMemo, useState } from "react";
import _ from "lodash";

const tabs = [
  {
    name: "Placing Slip",
    href: "PLACING_SLIP",
  },
  {
    name: "Supporting Documents",
    href: "SUPPORTING_DOCUMENTS",
  },
];

export default function ViewOfferSlipContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const [orderStatus, setOrderStatus] = useState("PLACING_SLIP");
  const searchParams = useSearch<LocationGenerics>();

  const urls = useMemo(
    () => ({
      PLACING_SLIP: `${config.asset.placeItUri}/generate-broker-placing-slip/${searchParams?.id}`,
      SUPPORTING_DOCUMENTS: `${config.asset.placeItUri}/generate-broker-supporting-docs/${searchParams?.id}`,
    }),
    [searchParams?.id, config.asset.placeItUri]
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="View Offer Slips"
      hidePadding
      description="Documents related to the offer are shown below"
    >
      <ModalTabs
        tabs={tabs}
        orderStatus={orderStatus}
        setOrderStatus={setOrderStatus}
      />
      <PDFRenderer url={_.get(urls, orderStatus)} />
    </Modal>
  );
}
